import lists from "./lists.json";
import main from "./main.json";
import formDesigner from "./formDesigner";
import alerts from "./alerts.json";
import elements from "./elements.json";
import common from "./common.json";

export default {
	translation: { main, formDesigner, lists, alerts, elements, common },
};
